<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div class="mt-3" id="versicherungsvariante" *ngIf="paket">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Gewählte Versicherungsvariante</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#leistungsuebersicht', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <strong>{{ (produkt.DeckungsumfangErhoehen === true ? 'Top ' : '') + 'Recht§vorteil - Paket ' + paket.PaketId + (produkt.FuerWenId === 1 || produkt.FuerWenId === 2 ? ' - Single/Alleinerzieher' : '') + ' (' + paket.Name + ')'}}</strong>
        </div>
      </div>
      <div class="row" *ngFor="let leistung of paket.Leistungen">
        <div class="leistung">
          <div class="col col-xs-12 col-sm-12">
            <p><strong>{{ leistung.Name }}</strong></p>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <p [innerHTML]="leistung.Beschreibung"></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-xs-12 col-sm-6">
          Für wen soll der Versicherungsschutz bestehen?
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ expertMode ? fuerWenOptionsExpert.get(produkt.FuerWenId) : fuerWenOptions.get(produkt.FuerWenId) }}
        </div>
      </div>
      <div class="row" *ngIf="produkt.PaketId === 1">
        <div class="col col-xs-12 col-sm-6">
          Kennzeichen:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Kennzeichen | uppercase }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Allgemeine Fragen</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#antrag_weiterefragen', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Wurde Ihnen bereits die Versicherung der beantragten Risiken gekündigt, abgelehnt oder einvernehmlich gelöst?
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ rsAntragComponent?.antragWeitereFragenComponent.kuendigungRisiken.value | toCapLetter }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ expertMode ? 'Wurde schon einmal eine Rechtsschutzversicherung abgeschlossen?' : 'Hatten Sie schon einmal eine Rechtsschutzversicherung?' }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ rsAntragComponent?.antragWeitereFragenComponent.vorversicherung.value | toCapLetter }}
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row" *ngIf="rsAntragComponent?.antragWeitereFragenComponent.vorversicherung.value === 'ja'">
            <div class="col col-xs-12 col-sm-6">
              Bisherige Rechtsschutzversicherung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ rsAntragComponent?.antragWeitereFragenComponent.vorversicherungComponent.sonstigeVersicherung.value ? rsAntragComponent.antragWeitereFragenComponent.vorversicherungComponent.sonstigeVersicherung.value : rsAntragComponent.antragWeitereFragenComponent.vorversicherungComponent.vorversicherungsUnternehmen.value ? rsAntragComponent.antragWeitereFragenComponent.vorversicherungComponent.vorversicherungsUnternehmen.value.Value : ''}}
            </div>
            <div class="col col-xs-12 col-sm-6">
              Bisherige Polizzennummer:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ rsAntragComponent?.antragWeitereFragenComponent.vorversicherungComponent.polizzennummerVorversicherung.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section praemie">
      <h6>Berechnete Prämie</h6>
      <div class="row">
        <div class="col col-xs-12 col-sm-6">
          Versicherungssumme (wertgesichert VPI 2000):
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          {{ versicherungssumme }}
        </div>
        <div class="col col-xs-12 col-sm-2"></div>
        <div class="col col-xs-12 col-sm-6">
          {{ 'Prämie (' + (produkt.ZahlungArtId === 1 ? 'jährlich' : produkt.ZahlungArtId === 2 ? 'halbjährlich' : produkt.ZahlungArtId === 3 ? 'vierteljährlich' : produkt.ZahlungArtId === 4 ? 'monatlich' : '') + ')' }}
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          {{ rsResult?.Gesamt | customCurrency }}
        </div>
        <div class="col col-xs-12 col-sm-2"></div>
      </div>
    </div>
  </div>
  <div class="row zusammenfassung-misc-questions">
    <div class="col col-xs-12 col-sm-12">
      <app-textarea #_besondereAnmerkungen [parentFormGroupDirective]="parentFormGroupDirective" [control]="besondereAnmerkungen" id="besondereAnmerkungen" label="Besondere Anmerkungen:"></app-textarea>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <app-vereinbarung-kommunikation [parentFormGroupDirective]="parentFormGroupDirective" [vereinbarungKommunikation]="vereinbarungKommunikation" [antrag]="true" [expertMode]="expertMode"></app-vereinbarung-kommunikation>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <app-datenschutz-policy [parentFormGroupDirective]="parentFormGroupDirective" [datenschutzPolicy]="datenschutzPolicy" [showDatenschutzPolicy]="!expertMode" [produktArt]="produktArt.Rechtschutz"></app-datenschutz-policy>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input_checkbox">
        <mat-checkbox formControlName="allgemeineVertragsgrundlagen">
          {{ expertMode ? 'Der Versicherungsnehmer erkennt die' : 'Ich erkenne die' }} <a [href]="translateService.get('LINKALLGEMEINEVERTRAGGRUNDLAGENRS') | async" class="textLink" target="blank">allgemeinen Vertragsgrundlagen</a> und die <a [href]="translateService.get('LINKSPARTENBEZOGENEVERSICHERUNGSBEDINGUNGEN') | async" class="textLink" target="_blank">spartenbezogenen Versicherungsbedingungen</a> für das gewählte Versicherungsprodukt/die gewählten Versicherungsprodukte an. *
        </mat-checkbox>
        <mat-error *ngIf="allgemeineVertragsgrundlagen.hasError('required') && (allgemeineVertragsgrundlagen.touched || parentFormGroupDirective.submitted)">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
</form>
